<template>
<div>
  <div>
    <el-switch
        v-model="showSummary"
        active-text="统计结果"
        class="switch">
      </el-switch>
      <div class="summary" v-show="showSummary">
        <div>
          <el-card style="box-shadow: 0px 28px 50px -25px rgba(0,0,0,0.3);">
              <div style="width:100%;border-bottom:1px solid #eee;display:flex;flex-direction:column;justify-content:flex-start">
                <!-- <div class="date">2018.01.01-2018.02.01</div> -->
                <div class="summary-title">数量</div>
              </div>
              <div style="width:100%;">
                <div class="summary-content"><span style="color: #43a047">{{summary.collected.qty}}</span> / {{summary.total.qty}}</div>
                <div class="summary-state">已揽收 / 总运单</div>
              </div>
            </el-card>
        </div>
        <div>
          <el-card style="box-shadow: 0px 28px 50px -25px rgba(0,0,0,0.3);">
              <div style="width:100%;border-bottom:1px solid #eee;display:flex;flex-direction:column;justify-content:flex-start">
                <!-- <div class="date">2018.01.01-2018.02.01</div> -->
                <div class="summary-title">重量 (LB)</div>
              </div>
              <div style="width:100%;">
                <div style="width:100%;">
                  <div class="summary-content"><span style="color: #43a047">{{summary.collected.weight}}</span> / {{summary.total.weight}}</div>
                  <div class="summary-state">已揽收 / 总运单</div>
                </div>
              </div>
            </el-card>
        </div>
        <div>
          <el-card style="box-shadow: 0px 28px 50px -25px rgba(0,0,0,0.3);">
              <div style="width:100%;border-bottom:1px solid #eee;display:flex;flex-direction:column;justify-content:flex-start">
                <!-- <div class="date">2018.01.01-2018.02.01</div> -->
                <div class="summary-title">总计</div>
              </div>
              <div style="width:100%;">
                <div style="width:100%;">
                  <div class="summary-content"><span style="color: #43a047">${{summary.collected.total}}</span> / ${{summary.total.total}}</div>
                  <div class="summary-state">已揽收 / 总运单</div>
                </div>
              </div>
            </el-card>
        </div>
        <div>
          <el-card style="box-shadow: 0px 28px 50px -25px rgba(0,0,0,0.3);">
              <div style="width:100%;border-bottom:1px solid #eee;display:flex;flex-direction:column;justify-content:flex-start">
                <!-- <div class="date">2018.01.01-2018.02.01</div> -->
                <div class="summary-title">寄送费</div>
              </div>
              <div style="width:100%;">
                <div style="width:100%;">
                  <div class="summary-content"><span style="color: #43a047">${{summary.collected.shipping}}</span> / ${{summary.total.shipping}}</div>
                  <div class="summary-state">已揽收 / 总运单</div>
                </div>
              </div>
            </el-card>
        </div>
        <div>
          <el-card style="box-shadow: 0px 28px 50px -25px rgba(0,0,0,0.3);">
              <div style="width:100%;border-bottom:1px solid #eee;display:flex;flex-direction:column;justify-content:flex-start">
                <!-- <div class="date">2018.01.01-2018.02.01</div> -->
                <div class="summary-title">税费</div>
              </div>
              <div style="width:100%;">
                <div style="width:100%;">
                  <div class="summary-content"><span style="color: #43a047">${{summary.collected.tax}}</span> / ${{summary.total.tax}}</div>
                  <div class="summary-state">已揽收 / 总运单</div>
                </div>
              </div>
            </el-card>
        </div>
        <div>
          <el-card style="box-shadow: 0px 28px 50px -25px rgba(0,0,0,0.3);">
              <div style="width:100%;border-bottom:1px solid #eee;display:flex;flex-direction:column;justify-content:flex-start">
                <!-- <div class="date">2018.01.01-2018.02.01</div> -->
                <div class="summary-title">保险费</div>
              </div>
              <div style="width:100%;">
                <div style="width:100%;">
                  <div class="summary-content"><span style="color: #43a047">${{summary.collected.insurance}}</span> / ${{summary.total.insurance}}</div>
                  <div class="summary-state">已揽收 / 总运单</div>
                </div>
              </div>
            </el-card>
        </div>
        <div>
          <el-card style="box-shadow: 0px 28px 50px -25px rgba(0,0,0,0.3);">
              <div style="width:100%;border-bottom:1px solid #eee;display:flex;flex-direction:column;justify-content:flex-start">
                <!-- <div class="date">2018.01.01-2018.02.01</div> -->
                <div class="summary-title">包装费</div>
              </div>
              <div style="width:100%;">
                <div style="width:100%;">
                  <div class="summary-content"><span style="color: #43a047">${{summary.collected.packing}}</span> / ${{summary.total.packing}}</div>
                  <div class="summary-state">已揽收 / 总运单</div>
                </div>
              </div>
            </el-card>
        </div>
      </div>
        <el-tabs v-model="activeOrder" @tab-click="activeOrderChange" type="border-card" class="order-table" style="margin-top:12px;" :stretch="true">
          <el-tab-pane label="全部" name="All">
            <div style="display:flex;margin-top:20px;">
              <div>
                <div class="block">
                <el-date-picker
                v-model="dateRange"
                type="daterange"
                range-separator="-"
                start-placeholder="起始日"
                end-placeholder="结束日"
                align="left"
                :editable="false"
                format="yyyy / MM / dd "
                value-format="yyyy-MM-dd"
                class="date-range">
                </el-date-picker>
                </div>
              </div>
            </div>
            <div class="buttons">
              <div class="buttons-set1">
                <el-dropdown trigger="click" @command="changeSearch" style="min-width:160px;">
                  <span class="el-dropdown-link" style="display:flex;justify-content:space-between;width:100%;">
                    {{ searchItem }}<i class="el-icon-arrow-down el-icon--right"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="All">全部</el-dropdown-item>
                    <el-dropdown-item command="Shipping No.">运单号</el-dropdown-item>
                    <el-dropdown-item command="Sender's Name">寄送人姓名</el-dropdown-item>
                    <el-dropdown-item command="Sender's Phone">寄送人手机号</el-dropdown-item>
                    <el-dropdown-item command="Recipient's Name">收件人姓名</el-dropdown-item>
                    <el-dropdown-item command="Recipient's Phone">收件人手机号</el-dropdown-item>
                    <el-dropdown-item command="Remark">留言</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
                <el-input
                  placeholder="请填写"
                  v-model="searchContent"
                  clearable
                  style="margin-top: 4px">
                </el-input>
                <div style="display: flex; align-items: center; margin-top: 4px">
                  <el-button @click="refreshQuery" icon="el-icon-search" circle style="margin-left:8px;"></el-button>
                  <el-button @click="clearQuery" icon="el-icon-close" circle style="margin-left:8px;"></el-button>
                </div>
              </div>
              <div class="buttons-set2">
                <el-button type="primary" icon="el-icon-refresh" @click="linkOrder" plain>刷新</el-button>
                <el-button type="primary" icon="el-icon-download" @click="exportToExcel" plain>导出表格 ({{targetOrder.length}}) </el-button>
              </div>
            </div>
        <el-table
          ref="multipleTable"
          :data="displayOrders"
          style="width: 100%;margin-top:32px"
          @selection-change="handleSelectionChange">
          <el-table-column
            type="selection"
            width="40"
            fixed="left">
          </el-table-column>
          <el-table-column
            label="日期"
            width="100">
          <template slot-scope="scope">{{ scope.row.date }}</template>
          </el-table-column>
          <el-table-column
            property="status"
            label="状态">
            <template slot-scope="scope">
              <div v-show="scope.row.status === 'Online'"><el-tag size="small" type="warning">Online</el-tag></div>
              <div v-show="scope.row.status === 'Collected'"><el-tag size="small" type="success">Collected</el-tag></div>
              <div v-show="scope.row.status === 'Cancelled'"><el-tag size="small" type="danger">Cancelled</el-tag></div>            
            </template>
          </el-table-column>
          <el-table-column
            property="shippingNo"
            label="运单号"
            width="130">
            <template slot-scope="scope"><div style="font-weight: bold;">{{ scope.row.shippingNo }}</div></template>
          </el-table-column>
          <el-table-column
            property="packDetail.totalWeight"
            label="重量(LB)">
          </el-table-column>
          <el-table-column
            property="totalFee"
            label="总计($)"
            width="80">
            <template slot-scope="scope"><div style="font-weight: bold; font-size: 1.1em;">{{ scope.row.totalFee }}</div></template>
          </el-table-column>
          <el-table-column
            property="shippingFee"
            label="寄送($)">
          </el-table-column>
          <el-table-column
            property="tax"
            label="税($)"
            width="70">
          </el-table-column>
          <el-table-column
            property="addInfo.insuranceFee"
            label="保险($)">
          </el-table-column>
          <el-table-column
            property="addInfo.packaged"
            label="打包方式">
            <template slot-scope="scope">
              <span v-show="(typeof scope.row.addInfo.packaged) === 'boolean'">{{ scope.row.addInfo.packaged ? '打包(Yes)' : '不打包(No)'}}</span>
              <span v-show="(typeof scope.row.addInfo.packaged) !== 'boolean'">{{ scope.row.addInfo.packingFee }}</span> <!-- Used to compatible with old data version -->
            </template>
          </el-table-column>
          <el-table-column
            label="寄件人"
            width="210">
            <template slot-scope="scope">
              <div>{{ scope.row.shipFrom.name }}</div>
              <div style="font-size: 0.8em;">{{ scope.row.shipFrom.phone}}</div>
              <div style="font-size: 0.8em;">{{ calcAddressString(scope.row.shipFrom, 'us') }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="收件人"
            width="210">
            <template slot-scope="scope">
              <div style="font-size: 1.1em; font-weight: bold;">{{ scope.row.shipTo.name }}</div>
              <div>P: {{ scope.row.shipTo.phone}}</div>
              <div style="font-size: 0.8em;">ID: {{ scope.row.shipTo.ID }}</div>
              <div style="font-size: 0.8em;"> {{ scope.row.shipTo.addressInfo }} </div>
              <div style="font-size: 0.8em;">{{ calcAddressString(scope.row.shipTo, 'cn') }}</div>
            </template>
          </el-table-column>
          <el-table-column
            property="addInfo.remark"
            label="留言">
          </el-table-column>
          <el-table-column type="expand" fixed="right">
            <template slot-scope="props">
                <el-table
                  :data="props.row.packDetail.items"
                  border
                  style="width: 100%">
                  <el-table-column
                    prop="qty"
                    label="数量">
                  </el-table-column>
                  <el-table-column
                    prop="name"
                    label="物品">
                  </el-table-column>
                  <el-table-column
                    prop="price"
                    label="单价 ($)">
                  </el-table-column>
                  <el-table-column
                    label="规格">
                    <template slot-scope="props">{{ props.row.spec }} {{props.row.specUnit}}</template>
                  </el-table-column>
                  <el-table-column
                    prop="weight"
                    label="重量 (LB)">
                  </el-table-column>
                </el-table>
                <div style="margin-top: 20px">
                  <el-button type="warning" @click="editOrder(props.row)" v-if="user.adminUser" plain>更改运单</el-button>
                  <el-button type="primary" @click="onlineOrder(props.row.orderID)" v-if="user.adminUser" plain>等待揽收</el-button>
                  <el-button type="success" @click="collectOrder(props.row.orderID)" v-if="user.adminUser" plain>确认揽收</el-button>
                  <el-button type="danger" @click="cancelOrder(props.row.orderID)" plain :disabled="props.row.status !== 'Online' && user.adminUser !== true">取消运单</el-button>
                </div>
            </template>
          </el-table-column>
          <template slot="empty">
            <half-circle-spinner
              v-if="!loadingBarTimeout"
              :animation-duration="1200"
              :size="48"
              color="#ff1d5e"
              style="margin:32px auto;"
            />
            <div v-if="loadingBarTimeout" style="position: absolute; top: 20px; left: 0; z-index: 999; background-color: #ffffff">
              您还没有任何运单哦, <a href="#" @click="$emit('to-shipping')"> 开始下单?</a>
            </div>
          </template>
        </el-table>
        <div style="overflow: auto; margin-top: 2rem">
          <el-pagination
            :current-page.sync="pageNum"
            background
            :layout="paginationLayout"
            @size-change="handleSizeChange"
            :page-size="pageSize"
            :page-sizes="[10, 20, 50, 100]"
            :total="filterOrders.length"
            style="padding-top:36px;padding-bottom:20px">
          </el-pagination>
        </div>
          </el-tab-pane>
          <el-tab-pane label="等待揽收" name="Online">
            <div style="display:flex;margin-top:20px;">
              <div>
                <div class="block">
                <el-date-picker
                v-model="dateRange"
                type="daterange"
                range-separator="-"
                start-placeholder="起始日"
                end-placeholder="结束日"
                align="left"
                :editable="false"
                format="yyyy / MM / dd "
                value-format="yyyy-MM-dd"
                class="date-range">
                </el-date-picker>
                </div>
              </div>
            </div>
            <div class="buttons">
              <div class="buttons-set1">
                <el-dropdown trigger="click" @command="changeSearch" style="min-width:160px;">
                  <span class="el-dropdown-link" style="display:flex;justify-content:space-between;width:100%;">
                    {{ searchItem }}<i class="el-icon-arrow-down el-icon--right"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="All">全部</el-dropdown-item>
                    <el-dropdown-item command="Shipping No.">运单号</el-dropdown-item>
                    <el-dropdown-item command="Sender's Name">寄件人姓名</el-dropdown-item>
                    <el-dropdown-item command="Sender's Phone">寄件人电话号</el-dropdown-item>
                    <el-dropdown-item command="Recipient's Name">收件人姓名</el-dropdown-item>
                    <el-dropdown-item command="Recipient's Phone">收件人电话号</el-dropdown-item>
                    <el-dropdown-item command="Remark">留言</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
                <el-input
                  placeholder="请填写"
                  v-model="searchContent"
                  clearable
                  style="margin-top: 4px">
                </el-input>
                <div style="display:flex; align-items: center; text-align: left; margin-top: 4px">
                  <el-button @click="refreshQuery" icon="el-icon-search" circle style="margin-left:8px;"></el-button>
                  <el-button @click="clearQuery" icon="el-icon-close" circle style="margin-left:8px;"></el-button>
                </div>
              </div>
              <div class="buttons-set2">
                <el-button type="primary" icon="el-icon-refresh" @click="linkOrder" plain>刷新</el-button>
                <el-button type="primary" icon="el-icon-download" @click="exportToExcel" plain>导出表格 ({{targetOrder.length}})</el-button>
              </div>
            </div>
        <el-table
          ref="multipleTable"
          :data="displayOrders"
          style="width: 100%;margin-top:32px"
          @selection-change="handleSelectionChange">
          <el-table-column
            type="selection"
            width="40"
            fixed="left">
          </el-table-column>
          <el-table-column
            label="日期"
            width="100">
          <template slot-scope="scope">{{ scope.row.date }}</template>
          </el-table-column>
          <el-table-column
            property="status"
            label="状态">
            <template slot-scope="scope">
              <div v-show="scope.row.status === 'Online'"><el-tag size="small" type="warning">Online</el-tag></div>
              <div v-show="scope.row.status === 'Collected'"><el-tag size="small" type="success">Collected</el-tag></div>
              <div v-show="scope.row.status === 'Cancelled'"><el-tag size="small" type="danger">Cancelled</el-tag></div>            
            </template>
          </el-table-column>
          <el-table-column
            property="shippingNo"
            label="运单号"
            width="130">
            <template slot-scope="scope"><div style="font-weight: bold;">{{ scope.row.shippingNo }}</div></template>
          </el-table-column>
          <el-table-column
            property="packDetail.totalWeight"
            label="重量(LB)">
          </el-table-column>
          <el-table-column
            property="totalFee"
            label="总计($)"
            width="80">
            <template slot-scope="scope"><div style="font-weight: bold; font-size: 1.1em;">{{ scope.row.totalFee }}</div></template>
          </el-table-column>
          <el-table-column
            property="shippingFee"
            label="寄送($)">
          </el-table-column>
          <el-table-column
            property="tax"
            label="税($)"
            width="70">
          </el-table-column>
          <el-table-column
            property="addInfo.insuranceFee"
            label="保险($)">
          </el-table-column>
          <el-table-column
            property="addInfo.packaged"
            label="打包方式">
            <template slot-scope="scope">
              <span v-show="(typeof scope.row.addInfo.packaged) === 'boolean'">{{ scope.row.addInfo.packaged ? '打包(Yes)' : '不打包(No)'}}</span>
              <span v-show="(typeof scope.row.addInfo.packaged) !== 'boolean'">{{ scope.row.addInfo.packingFee }}</span> <!-- Used to compatible with old data version -->
            </template>
          </el-table-column>
          <el-table-column
            label="寄件人"
            width="210">
            <template slot-scope="scope">
              <div>{{ scope.row.shipFrom.name }}</div>
              <div style="font-size: 0.8em;">{{ scope.row.shipFrom.phone}}</div>
              <div style="font-size: 0.8em;">{{ calcAddressString(scope.row.shipFrom, 'us') }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="收件人"
            width="210">
            <template slot-scope="scope">
              <div style="font-size: 1.1em; font-weight: bold;">{{ scope.row.shipTo.name }}</div>
              <div>P: {{ scope.row.shipTo.phone}}</div>
              <div style="font-size: 0.8em;">ID: {{ scope.row.shipTo.ID }}</div>
              <div style="font-size: 0.8em;"> {{ scope.row.shipTo.addressInfo }} </div>
              <div style="font-size: 0.8em;">{{ calcAddressString(scope.row.shipTo, 'cn') }}</div>
            </template>
          </el-table-column>
          <el-table-column
            property="addInfo.remark"
            label="留言">
          </el-table-column>
          <el-table-column type="expand" fixed="right">
            <template slot-scope="props">
                <el-table
                  :data="props.row.packDetail.items"
                  border
                  style="width: 100%">
                  <el-table-column
                    prop="qty"
                    label="重量">
                  </el-table-column>
                  <el-table-column
                    prop="name"
                    label="物品">
                  </el-table-column>
                  <el-table-column
                    prop="price"
                    label="价格 ($)">
                  </el-table-column>
                  <el-table-column
                    label="规格">
                    <template slot-scope="props">{{ props.row.spec }} {{props.row.specUnit}}</template>
                  </el-table-column>
                  <el-table-column
                    prop="weight"
                    label="重量 (LB)">
                  </el-table-column>
                </el-table>
                <div style="margin-top: 20px">
                  <el-button type="warning" @click="editOrder(props.row)" v-if="user.adminUser" plain>更改运单</el-button>
                  <el-button type="primary" @click="onlineOrder(props.row.orderID)" v-if="user.adminUser" plain>等待揽收</el-button>
                  <el-button type="success" @click="collectOrder(props.row.orderID)" v-if="user.adminUser" plain>确认揽收</el-button>
                  <el-button type="danger" @click="cancelOrder(props.row.orderID)" plain :disabled="props.row.status !== 'Online' && user.adminUser !== true">取消运单</el-button>
                </div>
            </template>
          </el-table-column>
          <template slot="empty">
            <half-circle-spinner
              v-if="!loadingBarTimeout"
              :animation-duration="1200"
              :size="48"
              color="#ff1d5e"
              style="margin:32px auto;"
            />
            <div v-if="loadingBarTimeout" style="position: absolute; top: 20px; left: 0; z-index: 999; background-color: #ffffff">
              您还没有任何运单哦,  <a href="#" @click="$emit('to-shipping')"> 开始下单?</a>
            </div>
          </template>
        </el-table>
        <div style="overflow: auto; margin-top: 2rem">
          <el-pagination
            :current-page.sync="pageNum"
            background
            :layout="paginationLayout"
            @size-change="handleSizeChange"
            :page-size="pageSize"
            :page-sizes="[10, 20, 50, 100]"
            :total="filterOrders.length"
            style="padding-top:36px;padding-bottom:20px">
          </el-pagination>
        </div>
          </el-tab-pane>
          <el-tab-pane label="已揽收" name="Collected">
            <div style="display:flex;margin-top:20px;">
              <div>
                <div class="block">
                <el-date-picker
                v-model="dateRange"
                type="daterange"
                range-separator="-"
                start-placeholder="起始日"
                end-placeholder="结束日"
                align="left"
                :editable="false"
                format="yyyy / MM / dd "
                value-format="yyyy-MM-dd"
                class="date-range">
                </el-date-picker>
                </div>
              </div>
            </div>
            <div class="buttons">
              <div class="buttons-set1">
                <el-dropdown trigger="click" @command="changeSearch" style="min-width:160px;">
                  <span class="el-dropdown-link" style="display:flex;justify-content:space-between;width:100%;">
                    {{ searchItem }}<i class="el-icon-arrow-down el-icon--right"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="All">全部</el-dropdown-item>
                    <el-dropdown-item command="Shipping No.">运单号</el-dropdown-item>
                    <el-dropdown-item command="Sender's Name">寄件人姓名</el-dropdown-item>
                    <el-dropdown-item command="Sender's Phone">寄件人手机号</el-dropdown-item>
                    <el-dropdown-item command="Recipient's Name">收件人姓名</el-dropdown-item>
                    <el-dropdown-item command="Recipient's Phone">收件人电话号</el-dropdown-item>
                    <el-dropdown-item command="Remark">留言</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
                <el-input
                  placeholder="请填写"
                  v-model="searchContent"
                  clearable
                  style="margin-top: 4px">
                </el-input>
                <div style="display: flex; align-items:center;margin-top: 4px">
                  <el-button @click="refreshQuery" icon="el-icon-search" circle style="margin-left:8px;"></el-button>
                  <el-button @click="clearQuery" icon="el-icon-close" circle style="margin-left:8px;"></el-button>
                </div>
              </div>
              <div class="buttons-set2">
                <el-button type="primary" icon="el-icon-refresh" @click="linkOrder" plain>刷新</el-button>
                <el-button type="primary" icon="el-icon-download" @click="exportToExcel" plain>导出表格 ({{targetOrder.length}})</el-button>
              </div>
            </div>
        <el-table
          ref="multipleTable"
          :data="displayOrders"
          style="width: 100%;margin-top:32px"
          @selection-change="handleSelectionChange">
          <el-table-column
            type="selection"
            width="40"
            fixed="left">
          </el-table-column>
          <el-table-column
            label="日期"
            width="100">
          <template slot-scope="scope">{{ scope.row.date }}</template>
          </el-table-column>
          <el-table-column
            property="status"
            label="状态">
            <template slot-scope="scope">
              <div v-show="scope.row.status === 'Online'"><el-tag size="small" type="warning">Online</el-tag></div>
              <div v-show="scope.row.status === 'Collected'"><el-tag size="small" type="success">Collected</el-tag></div>
              <div v-show="scope.row.status === 'Cancelled'"><el-tag size="small" type="danger">Cancelled</el-tag></div>            
            </template>          
          </el-table-column>
          <el-table-column
            property="shippingNo"
            label="运单号"
            width="130">
            <template slot-scope="scope"><div style="font-weight: bold;">{{ scope.row.shippingNo }}</div></template>
          </el-table-column>
          <el-table-column
            property="packDetail.totalWeight"
            label="重量(LB)">
          </el-table-column>
          <el-table-column
            property="totalFee"
            label="总计($)"
            width="80">
            <template slot-scope="scope"><div style="font-weight: bold; font-size: 1.1em;">{{ scope.row.totalFee }}</div></template>
          </el-table-column>
          <el-table-column
            property="shippingFee"
            label="寄送($)">
          </el-table-column>
          <el-table-column
            property="tax"
            label="税($)"
            width="70">
          </el-table-column>
          <el-table-column
            property="addInfo.insuranceFee"
            label="保险($)">
          </el-table-column>
          <el-table-column
            property="addInfo.packaged"
            label="打包方式">
            <template slot-scope="scope">
              <span v-show="(typeof scope.row.addInfo.packaged) === 'boolean'">{{ scope.row.addInfo.packaged ? '打包(Yes)' : '不打包(No)'}}</span>
              <span v-show="(typeof scope.row.addInfo.packaged) !== 'boolean'">{{ scope.row.addInfo.packingFee }}</span> <!-- Used to compatible with old data version -->
            </template>
          </el-table-column>
          <el-table-column
            label="寄件人"
            width="210">
            <template slot-scope="scope">
              <div>{{ scope.row.shipFrom.name }}</div>
              <div style="font-size: 0.8em;">{{ scope.row.shipFrom.phone}}</div>
              <div style="font-size: 0.8em;">{{ calcAddressString(scope.row.shipFrom, 'us') }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="收件人"
            width="210">
            <template slot-scope="scope">
              <div style="font-size: 1.1em; font-weight: bold;">{{ scope.row.shipTo.name }}</div>
              <div>P: {{ scope.row.shipTo.phone}}</div>
              <div style="font-size: 0.8em;">ID: {{ scope.row.shipTo.ID }}</div>
              <div style="font-size: 0.8em;"> {{ scope.row.shipTo.addressInfo }} </div>
              <div style="font-size: 0.8em;">{{ calcAddressString(scope.row.shipTo, 'cn') }}</div>
            </template>
          </el-table-column>
          <el-table-column
            property="addInfo.remark"
            label="留言">
          </el-table-column>
          <el-table-column type="expand" fixed="right">
            <template slot-scope="props">
                <el-table
                  :data="props.row.packDetail.items"
                  border
                  style="width: 100%">
                  <el-table-column
                    prop="qty"
                    label="数量">
                  </el-table-column>
                  <el-table-column
                    prop="name"
                    label="物品">
                  </el-table-column>
                  <el-table-column
                    prop="price"
                    label="价格 ($)">
                  </el-table-column>
                  <el-table-column
                    label="规格">
                    <template slot-scope="props">{{ props.row.spec }} {{props.row.specUnit}}</template>
                  </el-table-column>
                  <el-table-column
                    prop="weight"
                    label="重量 (LB)">
                  </el-table-column>
                </el-table>
                <div style="margin-top: 20px">
                  <el-button type="warning" @click="editOrder(props.row)" v-if="user.adminUser" plain>更改运单</el-button>
                  <el-button type="primary" @click="onlineOrder(props.row.orderID)" v-if="user.adminUser" plain>等待揽收</el-button>
                  <el-button type="success" @click="collectOrder(props.row.orderID)" v-if="user.adminUser" plain>确认揽收</el-button>
                  <el-button type="danger" @click="cancelOrder(props.row.orderID)" plain :disabled="props.row.status !== 'Online' && user.adminUser !== true">取消运单</el-button>
                </div>
            </template>
          </el-table-column>
          <template slot="empty">
            <half-circle-spinner
              v-if="!loadingBarTimeout"
              :animation-duration="1200"
              :size="48"
              color="#ff1d5e"
              style="margin:32px auto;"
            />
            <div v-if="loadingBarTimeout" style="position: absolute; top: 20px; left: 0; z-index: 999; background-color: #ffffff">
              您还没有任何运单哦,  <a href="#" @click="$emit('to-shipping')"> 开始下单?</a>
            </div>
          </template>
        </el-table>
        <div style="overflow: auto; margin-top: 2rem">
          <el-pagination
            :current-page.sync="pageNum"
            background
            :layout="paginationLayout"
            @size-change="handleSizeChange"
            :page-size="pageSize"
            :page-sizes="[10, 20, 50, 100]"
            :total="filterOrders.length"
            style="padding-top:36px;padding-bottom:20px">
          </el-pagination>
        </div>
          </el-tab-pane>
          <el-tab-pane label="已取消" name="Cancelled">
            <div style="display:flex;margin-top:20px;">
              <div>
                <div class="block">
                <el-date-picker
                v-model="dateRange"
                type="daterange"
                range-separator="-"
                start-placeholder="起始日"
                end-placeholder="结束日"
                align="left"
                :editable="false"
                format="yyyy / MM / dd "
                value-format="yyyy-MM-dd"
                class="date-range">
                </el-date-picker>
                </div>
              </div>
            </div>
            <div class="buttons">
              <div class="buttons-set1">
                <el-dropdown trigger="click" @command="changeSearch" style="min-width:160px;">
                  <span class="el-dropdown-link" style="display:flex;justify-content:space-between;width:100%;">
                    {{ searchItem }}<i class="el-icon-arrow-down el-icon--right"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="All">全部</el-dropdown-item>
                    <el-dropdown-item command="Shipping No.">运单号</el-dropdown-item>
                    <el-dropdown-item command="Sender's Name">寄件人姓名</el-dropdown-item>
                    <el-dropdown-item command="Sender's Phone">寄件人电话号</el-dropdown-item>
                    <el-dropdown-item command="Recipient's Name">收件人姓名</el-dropdown-item>
                    <el-dropdown-item command="Recipient's Phone">收件人电话号</el-dropdown-item>
                    <el-dropdown-item command="Remark">留言</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
                <el-input
                  placeholder="请填写"
                  v-model="searchContent"
                  clearable
                  style="margin-top: 4px">
                </el-input>
                <div style="display:flex; align-items: center; margin-top: 4px">
                  <el-button @click="refreshQuery" icon="el-icon-search" circle style="margin-left:8px;"></el-button>
                  <el-button @click="clearQuery" icon="el-icon-close" circle style="margin-left:8px;"></el-button>
                </div>
              </div>
              <div class="buttons-set2">
                <el-button type="primary" icon="el-icon-refresh" @click="linkOrder" plain>刷新</el-button>
                <el-button type="primary" icon="el-icon-download" @click="exportToExcel" plain>导出表格 ({{targetOrder.length}})</el-button>
              </div>
            </div>
        <el-table
          ref="multipleTable"
          :data="displayOrders"
          style="width: 100%;margin-top:32px"
          @selection-change="handleSelectionChange">
          <el-table-column
            type="selection"
            width="40"
            fixed="left">
          </el-table-column>
          <el-table-column
            label="日期"
            width="100">
          <template slot-scope="scope">{{ scope.row.date }}</template>
          </el-table-column>
          <el-table-column
            property="status"
            label="状态">
            <template slot-scope="scope">
              <div v-show="scope.row.status === 'Online'"><el-tag size="small" type="warning">Online</el-tag></div>
              <div v-show="scope.row.status === 'Collected'"><el-tag size="small" type="success">Collected</el-tag></div>
              <div v-show="scope.row.status === 'Cancelled'"><el-tag size="small" type="danger">Cancelled</el-tag></div>            
            </template>          
          </el-table-column>
          <el-table-column
            property="shippingNo"
            label="运单号"
            width="130">
            <template slot-scope="scope"><div style="font-weight: bold;">{{ scope.row.shippingNo }}</div></template>
          </el-table-column>
          <el-table-column
            property="packDetail.totalWeight"
            label="重量(LB)">
          </el-table-column>
          <el-table-column
            property="totalFee"
            label="总计($)"
            width="80">
            <template slot-scope="scope"><div style="font-weight: bold; font-size: 1.1em;">{{ scope.row.totalFee }}</div></template>
          </el-table-column>
          <el-table-column
            property="shippingFee"
            label="寄送($)">
          </el-table-column>
          <el-table-column
            property="tax"
            label="税($)"
            width="70">
          </el-table-column>
          <el-table-column
            property="addInfo.insuranceFee"
            label="保险($)">
          </el-table-column>
          <el-table-column
            property="addInfo.packaged"
            label="打包方式">
            <template slot-scope="scope">
              <span v-show="(typeof scope.row.addInfo.packaged) === 'boolean'">{{ scope.row.addInfo.packaged ? '打包(Yes)' : '不打包(No)'}}</span>
              <span v-show="(typeof scope.row.addInfo.packaged) !== 'boolean'">{{ scope.row.addInfo.packingFee }}</span> <!-- Used to compatible with old data version -->
            </template>
          </el-table-column>
          <el-table-column
            label="寄件人"
            width="210">
            <template slot-scope="scope">
              <div>{{ scope.row.shipFrom.name }}</div>
              <div style="font-size: 0.8em;">{{ scope.row.shipFrom.phone}}</div>
              <div style="font-size: 0.8em;">{{ calcAddressString(scope.row.shipFrom, 'us') }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="收件人"
            width="210">
            <template slot-scope="scope">
              <div style="font-size: 1.1em; font-weight: bold;">{{ scope.row.shipTo.name }}</div>
              <div>P: {{ scope.row.shipTo.phone}}</div>
              <div style="font-size: 0.8em;">ID: {{ scope.row.shipTo.ID }}</div>
              <div style="font-size: 0.8em;"> {{ scope.row.shipTo.addressInfo }} </div>
              <div style="font-size: 0.8em;">{{ calcAddressString(scope.row.shipTo, 'cn') }}</div>
            </template>
          </el-table-column>
          <el-table-column
            property="addInfo.remark"
            label="留言">
          </el-table-column>
          <el-table-column type="expand" fixed="right">
            <template slot-scope="props">
                <el-table
                  :data="props.row.packDetail.items"
                  border
                  style="width: 100%">
                  <el-table-column
                    prop="qty"
                    label="重量">
                  </el-table-column>
                  <el-table-column
                    prop="name"
                    label="物品">
                  </el-table-column>
                  <el-table-column
                    prop="price"
                    label="价格 ($)">
                  </el-table-column>
                  <el-table-column
                    label="规格">
                    <template slot-scope="props">{{ props.row.spec }} {{props.row.specUnit}}</template>
                  </el-table-column>
                  <el-table-column
                    prop="weight"
                    label="重量 (LB)">
                  </el-table-column>
                </el-table>
                <div style="margin-top: 20px">
                  <el-button type="warning" @click="editOrder(props.row)" v-if="user.adminUser" plain>更改运单</el-button>
                  <el-button type="primary" @click="onlineOrder(props.row.orderID)" v-if="user.adminUser" plain>等待揽收</el-button>
                  <el-button type="success" @click="collectOrder(props.row.orderID)" v-if="user.adminUser" plain>确认揽收</el-button>
                  <el-button type="danger" @click="cancelOrder(props.row.orderID)" plain :disabled="props.row.status !== 'Online' && user.adminUser !== true">取消运单</el-button>
                </div>
            </template>
          </el-table-column>
          <template slot="empty">
            <half-circle-spinner
              v-if="!loadingBarTimeout"
              :animation-duration="1200"
              :size="48"
              color="#ff1d5e"
              style="margin:32px auto;"
            />
            <div v-if="loadingBarTimeout" style="position: absolute; top: 20px; left: 0; z-index: 999; background-color: #ffffff">
              您还没有任何运单哦, <a href="#" @click="$emit('to-shipping')"> 开始下单?</a>
            </div>
          </template>
        </el-table>
        <div style="overflow: auto; margin-top: 2rem">
          <el-pagination
            :current-page.sync="pageNum"
            background
            :layout="paginationLayout"
            @size-change="handleSizeChange"
            :page-size="pageSize"
            :page-sizes="[10, 20, 50, 100]"
            :total="filterOrders.length"
            style="padding-top:36px;padding-bottom:20px">
          </el-pagination>
        </div>
          </el-tab-pane>
        </el-tabs>
      <order-editor
        v-if="showOrderEditor"
        v-on:close-editor="showOrderEditor = false"
        :order="formOrder"
        :user="user">
      </order-editor>
  </div>
</div>
</template>

<script>
import { db } from '../main'
import { HalfCircleSpinner } from 'epic-spinners'
import { assignAnonymous, changeOrderStatus } from '../../public/js/shipping'
import { exportToExcel } from '../../public/js/exportOrder'
import OrderEditor from '@/components/OrderEditor'

export default {
  name: 'Orders',
  props: ['user'],
  data () {
    return {
      searchContent: '',
      dateRange: '',
      showSummary: false,
      activeOrder: 'All',
      edit: false,
      editForm: false,
      searchItem: 'All',
      queryOrders: [],
      orders: [],
      loadingBarTimeout: false,
      canRefresh: true,
      pageNum: 1,
      pageSize: 20,
      tempPageSize: 20,
      selectedOrderIndex: [],
      editingOrder: {},
      showOrderEditor: false,
      paginationLayout: 'total, sizes, prev, pager, next'
    }
  },
  timers: {
    linkOrder: {
      time: 1000,
      autostart: true,
      repeat: false
    },
    killLoadingBar: {
      time: 10000,
      autostart: false,
      repeat: false
    }
  },
  methods: {
    dropdown: function () {
      this.dropdownOpen = !this.dropdownOpen
    },
    dropdownMobile: function () {
      this.dropdownOpenMobile = !this.dropdownOpenMobile
    },
    activeOrderChange: function () {
      // console.log(event)
    },
    changeSearch: function (command) {
      this.searchItem = command
    },
    refreshQuery: function () {
      let start = this.dateRange[0]
      let end = this.dateRange[1]
      let key = this.searchItem
      let value = this.searchContent

      // console.log('do search =>', start, end, key, value)

      var allOrders = this.orders
      var afterTime = []
      var afterKey = []

      if (start && end) {
        // filter the time
        for (let i = 0; i < allOrders.length; i++) {
          let order = allOrders[i]
          if (order.date >= start && order.date <= end) {
            afterTime.push(order)
          }
        }
      } else {
        // skip the time field
        afterTime = allOrders
      }
      // console.log('after time', afterTime)

      switch (key) {
        case 'All':
          afterKey = afterTime
          break
        // eslint-disable-next-line
        case "Shipping No.":
          for (let i = 0; i < afterTime.length; i++) {
            let order = afterTime[i]
            if (String(order.shippingNo) === value) {
              afterKey.push(order)
            }
          }
          break
        // eslint-disable-next-line
        case "Sender's Name":
          for (let i = 0; i < afterTime.length; i++) {
            let order = afterTime[i]
            if (order.shipFrom.name.indexOf(value) !== -1) {
              afterKey.push(order)
            }
          }
          break
        // eslint-disable-next-line
        case "Sender's Phone":
          for (let i = 0; i < afterTime.length; i++) {
            let order = afterTime[i]
            if (order.shipFrom.phone === value) {
              afterKey.push(order)
            }
          }
          break
        // eslint-disable-next-line
        case "Recipient's Name":
          for (let i = 0; i < afterTime.length; i++) {
            let order = afterTime[i]
            if (order.shipTo.name.indexOf(value) !== -1) {
              afterKey.push(order)
            }
          }
          break
        // eslint-disable-next-line
        case "Recipient's Phone":
          for (let i = 0; i < afterTime.length; i++) {
            let order = afterTime[i]
            if (order.shipTo.phone === value) {
              afterKey.push(order)
            }
          }
          break
        // eslint-disable-next-line
        case "Remark":
          for (let i = 0; i < afterTime.length; i++) {
            let order = afterTime[i]
            if (order.addInfo.remark.indexOf(value) !== -1) {
              afterKey.push(order)
            }
          }
          break
        default:
          afterKey = afterTime
      }
      // console.log('after key', afterKey)
      this.queryOrders = afterKey
      this.tempPageSize = this.pageSize
      this.pageSize = this.queryOrders.length
      this.paginationLayout = 'total'
    },
    clearQuery: function () {
      this.dateRange = ''
      this.searchContent = ''
      this.searchItem = 'All'
      this.queryOrders = this.orders
      this.pageSize = 20
      this.paginationLayout = 'total, sizes, prev, pager, next'
    },
    exportToExcel: function () {
      if (this.targetOrder.length === 0) {
        this.$message.error('未选择运单')
      } else {
        exportToExcel(this.targetOrder, this.user.adminUser)
      }
    },
    handleSelectionChange: function (val) {
      this.selectedOrderIndex = val
    },
    linkOrder: function () {
      this.canRefresh = false
      // reset loading bar timer
      this.$timer.stop('killLoadingBar')
      this.$timer.start('killLoadingBar')
      this.loadingBarTimeout = false

      // link the database data
      let user = this.user
      if (user) {
        if (user.ready) {
          // console.log('user ready, starting bind')
          if (user.superAdmin) {
            // console.log('super user, bind all')
            this.$bind('orders', db.collection('order').orderBy('stamp', 'desc'))
          } else if (user.adminUser) {
            // console.log('store user, bind store')
            this.$bind('orders', db.collection('order').where('storeGroup', '==', user.storeGroup).orderBy('stamp', 'desc'))
          } else {
            // console.log('normal user, bind own')
            this.$bind('orders', db.collection('order').where('owner', '==', this.user.uid).orderBy('stamp', 'desc'))
            // assign anonymous orders
            let that = this
            assignAnonymous(user).then(result => {
              // console.log(result)
              that.canRefresh = true
            }).catch(err => {
              // console.log('Error at ASSIGN ANONYMOUS =>', err)
              that.canRefresh = true
            })
          }
        } else {
          // console.log('user not ready for bind')
          this.canRefresh = true
        }
      } else {
        // console.log('can\'t bind null user')
        this.canRefresh = true
      }
      this.queryOrders = this.orders
    },
    killLoadingBar: function () {
      this.loadingBarTimeout = true
    },
    handleSizeChange: function (val) {
      this.pageSize = val
    },
    calcAddressString: function (address, local) {
      let addressStr = ''
      if (local === 'us') {
        addressStr = address.address1 + ' ' +
                      address.address2 + ', ' +
                      address.city + ', ' +
                      address.state + ', ' +
                      address.postal + ', ' +
                      address.country
      } else if (local === 'cn') {
        addressStr = address.province + ', ' +
                      address.city + ', ' +
                      address.district + ', ' +
                      address.postal + ', ' +
                      address.country
      } else {
        throw new Error('Local code invalid!')
      }
      return addressStr
    },
    editOrder: function (order) {
      this.editingOrder = order
      this.showOrderEditor = true
    },
    collectOrder: function (orderID) {
      return changeOrderStatus(orderID, 'Collected', this.user)
        .then(result => {
          // console.log(result)
          // console.log('collect =>', orderID)
        })
        .catch(err => {
          // console.log(err)
        })
    },
    cancelOrder: function (orderID) {
      return changeOrderStatus(orderID, 'Cancelled', this.user)
        .then(result => {
          // console.log(result)
          // console.log('cancel =>', orderID)
        })
        .catch(err => {
          // console.log(err)
        })
    },
    onlineOrder: function (orderID) {
      return changeOrderStatus(orderID, 'Online', this.user)
        .then(result => {
          // console.log(result)
          // console.log('online =>', orderID)
        })
        .catch(err => {
          // console.log(err)
        })
    }
  },
  watch: {
    user: function () {
      this.linkOrder()
    }
  },
  computed: {
    filterOrders: function () {
      // TODO: Add filter for tab query
      let currentTab = this.activeOrder
      let queryOrders = this.queryOrders
      let tabOrders = []

      if (currentTab === 'All') {
        return queryOrders
      }
      for (var i = 0; i < queryOrders.length; i++) {
        let order = queryOrders[i]
        if (order.status === currentTab) {
          tabOrders.push(order)
        }
      }
      return tabOrders
    },
    displayOrders: function () {
      let start = (this.pageNum - 1) * this.pageSize
      let end = start + this.pageSize
      return this.filterOrders.slice(start, end)
    },
    formOrder: function () {
      var orderCopy = JSON.parse(JSON.stringify(this.editingOrder))
      return orderCopy
    },
    targetOrder: function () {
      if (this.selectedOrderIndex.length !== 0) {
        return this.selectedOrderIndex
      } else {
        return this.filterOrders
      }
    },
    summary: function () {
      let total = {
        qty: 0,
        weight: 0,
        total: 0,
        shipping: 0,
        tax: 0,
        insurance: 0,
        packing: 0
      }
      let collected = {
        qty: 0,
        weight: 0,
        total: 0,
        shipping: 0,
        tax: 0,
        insurance: 0,
        packing: 0
      }
      // count all orders in targetOrder
      for (var i = 0; i < this.targetOrder.length; i++) {
        let order = this.targetOrder[i]
        total.qty += 1
        total.weight += parseFloat(order.packDetail.totalWeight)
        total.total += parseFloat(order.totalFee)
        total.shipping += parseFloat(order.shippingFee)
        total.tax += parseFloat(order.tax)
        total.insurance += parseFloat(order.addInfo.insuranceFee)
        total.packing += parseFloat(order.addInfo.packingFee)

        if (order.status === 'Collected') {
          collected.qty += 1
          collected.weight += parseFloat(order.packDetail.totalWeight)
          collected.total += parseFloat(order.totalFee)
          collected.shipping += parseFloat(order.shippingFee)
          collected.tax += parseFloat(order.tax)
          collected.insurance += parseFloat(order.addInfo.insuranceFee)
          collected.packing += parseFloat(order.addInfo.packingFee)
        }
      }
      for (var prop in total) {
        if (prop === 'qty') {
          total.qty = total.qty.toFixed(0)
          collected.qty = collected.qty.toFixed(0)
        } else {
          total[prop] = total[prop].toFixed(2)
          collected[prop] = collected[prop].toFixed(2)
        }
      }
      return {
        collected: collected,
        total: total
      }
    }
  },
  components: { HalfCircleSpinner, OrderEditor }
}

</script>

<style>
  p {
    text-align: left;
  }
  .span {
    font-size: 2rem;
  }
  .buttons {
    margin-top: 12px;
    margin-bottom:12px;
    padding-top: 0;
    display:flex;
    justify-content:space-between;
  }
  .buttons-set1 {
    display: flex;
    align-items: center;
  }
  .cell {
    text-align: left;
  }
  .switch {
    display: flex;
    justify-content: flex-start;
    margin-bottom: 20px;
  }
  .summary {
    display: grid;
    grid-gap: 10px;
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    margin-bottom: 40px;
    animation: summaryShow 0.8s ease;
  }
  .date {
    font-size: 14px;
    color: rgba(0, 0, 0, 0.75);
    text-align:left;
  }
  .summary-title {
    padding: 8px 0px 12px 0;
    font-size: 20px;
    color: rgba(0, 0, 0, 0.9);
    text-align:left;
  }
  .summary-content {
    font-family:'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif;
    padding: 20px 0 12px 0px;
    font-size: 30px;
    color: rgba(0, 0, 0, 0.9);
    text-align:left;
  }
  .summary-state {
    padding: 0 0 4px 0px;
    font-size: 14px;
    color: rgba(0, 0, 0, 0.75);
    text-align:left;
  }
  /* .el-date-editor .el-range-separator {
    width: 20px;
  } */
  /* .el-date-editor--daterange.el-input, .el-date-editor--daterange.el-input__inner, .el-date-editor--timerange.el-input, .el-date-editor--timerange.el-input__inner {
    width: 300px;
  }
  .el-date-editor .el-range-separator {
    width: 10%;
  } */
  /* .edit-wrapper {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    background-color: rgba(0, 0, 0, 0.4);
    z-index: 1000;
    -webkit-overflow-scrolling: touch;
  }
  .edit-form {
    box-sizing: border-box;
    padding: 20px;
    width: 600px;
    margin: auto;
    height: 80vh;
    overflow: auto;
    background: #ffffff;
    border-radius: 5px;
  } */
  .el-dropdown {
    border: 1px solid #e0e0e0;
    border-radius: 5px;
    padding:9px;
    margin-right: 8px;
  }
  .el-card__body {
    padding: 20px;
  }
  @keyframes summaryShow {
    from  { opacity: 0; }
    to    { opacity: 1; }
  }
  @media (max-width: 850px) {
    .buttons {
      /* height: 90px; */
      margin-top: 12px;
      margin-bottom:12px;
      display:flex;
      flex-direction: column;
      /* justify-content: space-between;
      align-items: flex-start; */
    }
    .buttons-set1 {
      display: block;
      text-align: left
    }
    .buttons-set2 {
      margin-top: 24px;
      display:flex;
      align-items:center
    }
    .el-card__body {
    padding: 20px;
  }
  @media (max-width: 1024px) {
    .el-card__body {
      padding: 20px;
    }
  }
  @media (max-width: 1440px) {
    .el-card__body {
      padding: 20px;
    }
  }
  }
</style>
